export enum ROUTES {
    OAUTH_CALLBACK = '/oauth-callback',
    ROOT = '/',
    LOGIN = '/login',
    SIGN_UP = '/sign-up',
    SIGN_UP_CREATE_ACCOUNT = '/sign-up/create-account',
    SIGN_UP_EXISTING_PASSENGER_ACCOUNT = '/sign-up/existing-passenger-account',
    SIGN_UP_LOGIN = '/sign-up/login',
    SIGN_UP_VERIFY_PHONE_NUMBER = '/sign-up/verify-phone-number',
    JOIN_COMPANY = '/join-company',
    JOIN_COMPANY_JOIN = '/join-company/join',
    JOIN_COMPANY_INVITATION = '/join-company/:companyName/:inviteId/:emailAddress',
    JOIN_COMPANY_INVITATION_LOGIN = '/join-company/:companyName/:inviteId/:emailAddress/login',
    JOIN_COMPANY_INVITATION_REGISTER = '/join-company/:companyName/:inviteId/:emailAddress/register',
    JOIN_COMPANY_SUCCESS = '/join-company/:companyName/success',
    JOIN_COMPANY_RIBAC_QR_CODE_LANDINGPAGE = '/join-company/self-join',
    CREDIT_CARD_REDIRECT = '/credit-card-redirect',
    GET_STARTED = '/get-started',
    DASHBOARD = '/dashboard',
    TRIPS = '/trips',
    EMPLOYEES = '/employees',
    EMPLOYEES_APPROVED = '/employees/approved',
    EMPLOYEES_INVITED = '/employees/invited',
    EMPLOYEES_GROUPS = '/employees/groups',
    EMPLOYEES_GROUPS_NEW = '/employees/groups/new',
    EMPLOYEES_GROUPS_DETAIL = '/employees/groups/:groupId',
    EMPLOYEES_AWAITING_APPROVAL = '/employees/awaiting-approval',
    COST_CENTRES = '/cost-centres',
    STATEMENTS = '/statements',
    ACCOUNT = '/account',
    ACCOUNT_INFORMATION = '/account/information',
    ACCOUNT_INVITATIONS = '/account/invitations',
    ACCOUNT_SETTINGS = '/account/settings',
    ACCOUNT_TRAVEL_ABROAD = '/account/travel-abroad',
    ACCOUNT_PAYMENT = '/account/payment',
    RIDE_REFERENCES = '/ride-references',
    INTEGRATIONS = '/integrations',
    INVITATION_LINK_LANDINGPAGE = '/invitation-link/:invitationLinkToken',
    POLICIES = '/policies',
    POLICIES_LIST = '/policies/list',
    CREATE_POLICIES = '/policies/new',
    EDIT_POLICIES = '/policies/:policyId',
    BUSINESS_PROFILE_EMAIL_VERIFICATION = '/business-profiles/work-email-verification',
    INTEGRATIONS_LIST = '/integrations/list',
    INTEGRATIONS_DETAILS = '/integrations/details',
    CONCUR_CONNECT = '/concur/connect',
    SUSTAINABILITY = '/sustainability',
}

export const CO_ROUTE = '/central-organisation/:centralOrganisationId';
export const CO_BA_ROUTE = '/central-organisation/:centralOrganisationId/business-account/:businessAccountId';
